// extracted by mini-css-extract-plugin
module.exports = {"link":"AuthNav_link__bKeVS","activeLink":"AuthNav_activeLink__1C-6k AuthNav_link__bKeVS"};